module.exports = __webpack_public_path__ + "e723848039d4f815dc0329a1a75134c3.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/alamo.png
// module id = 978
// module chunks = 2